import { useState, useEffect } from 'react';
import Header from '../components/Header';
import VideoHero from '../components/VideoHero';
import BespokeSection from '../components/BespokeSection';
import ServicesGrid from '../components/ServicesGrid';
import AboutSection from '../components/AboutSection';
import PricingContact from '../components/PricingContact';
import PartnershipsSection from '../components/PartnershipsSection';
import Footer from '../components/Footer';
import ConsultationModal from '../components/ConsultationModal';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'about', 'contact', 'partnerships'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openConsultation = () => setIsConsultationOpen(true);
  const closeConsultation = () => setIsConsultationOpen(false);

  return (
    <div className="homepage">
      <Header activeSection={activeSection} onOpenConsultation={openConsultation} />
      <VideoHero onOpenConsultation={openConsultation} />
      <BespokeSection />
      <ServicesGrid />
      <AboutSection />
      <PricingContact onOpenConsultation={openConsultation} />
      <PartnershipsSection />
      <Footer />
      <ConsultationModal isOpen={isConsultationOpen} onClose={closeConsultation} />
    </div>
  );
};

export default HomePage;
